/**
 * Video
 *
 * Copyright (c) 2020 Aperia Company
 * Released under the MIT license
 */

"use strict";
import { isExists } from "@utils/validate";

/**
 * Video Object
 */
const Video = function (el) {
  const EL_BTN_PLAY = ".btn-play";

  this.initVideo = function () {
    $(EL_BTN_PLAY).on("click", function (e) {
      e.preventDefault();
      $(this).fadeOut();
      $(this).prev().fadeOut();
      $(el).fadeIn();
      let iframe = $(el).find("iframe");
      let video = $(el).find("video");
      console.log(iframe);

      if (isExists(iframe)) $("iframe")[0].src += "&autoplay=1&rel=0&controls=0&showinfo=0";
      if (isExists(video)) $("video")[0].play();
    });
  };

  this.init = function () {
    if (!isExists(el)) {
      return;
    }
    this.initVideo();
  };

  return this.init();
};
export default Video;
